{
    "meta": {
        "title": "Si necesitas enviar dinero a {country} hazte miembro - MAJORITY",
        "description": "¡Ahorra al enviar dinero a {country}! Envía dinero a {country} sin cargos a tipos de cambio competitivos y con entrega rápida. ¡Descubre nuestra App financiera!"
    },
    "hero": {
        "title": "Enviar dinero a {country}",
        "body": "Estamos trabajando duro para ofrecerte la oportunidad de enviar dinero a {country} sin cargos extra. En breve tendremos preparada tu app para enviar dinero a {country}. Vuelve pronto.",
        "cta": "Ver más países"
    }
}
